"use client";

export function GlassBar({
  children,
  className = "",
  position = "top",
  isFloating = false,
}: {
  children: React.ReactNode;
  className?: string;
  position?: "top" | "bottom";
  isFloating?: boolean;
}) {
  const pos =
    position === "top"
      ? "fixed top-0 left-0 right-0 safe-top"
      : "fixed bottom-0 left-0 right-0 safe-bottom";

  if (position === "bottom") {
    return (
      <div
        className={[pos, "z-50", "bg-[#f3f3f3]", "border-t border-zinc-200/80", className].join(" ")}
      >
        {children}
      </div>
    );
  }

  return (
    <div className={`${pos} z-50 pointer-events-none px-0`}>
      <div
        className={[
          "pointer-events-auto transition-all duration-500 ease-out",
          isFloating
            ? "mx-3 mt-2 max-w-6xl overflow-hidden rounded-2xl border border-zinc-200/70 shadow-[0_8px_30px_rgba(0,0,0,0.06)] backdrop-blur-xl sm:mx-auto sm:mt-3 sm:px-2"
            : "w-full bg-transparent",
          className,
        ].join(" ")}
        style={
          isFloating
            ? {
                background: "rgba(255, 255, 255, 0.72)",
                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
                transform: "translate3d(0, 0, 0)",
                WebkitTransform: "translate3d(0, 0, 0)",
                backfaceVisibility: "hidden",
                WebkitBackfaceVisibility: "hidden",
              }
            : {
                transform: "translate3d(0, 0, 0)",
                WebkitTransform: "translate3d(0, 0, 0)",
                backfaceVisibility: "hidden",
                WebkitBackfaceVisibility: "hidden",
              }
        }
      >
        <div className="relative">{children}</div>
      </div>
    </div>
  );
}
